/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CarveOutQuote } from './CarveOutQuote';
import {
    CarveOutQuoteFromJSON,
    CarveOutQuoteFromJSONTyped,
    CarveOutQuoteToJSON,
    CarveOutQuoteToJSONTyped,
} from './CarveOutQuote';
import type { CarveOutEligibilityReason } from './CarveOutEligibilityReason';
import {
    CarveOutEligibilityReasonFromJSON,
    CarveOutEligibilityReasonFromJSONTyped,
    CarveOutEligibilityReasonToJSON,
    CarveOutEligibilityReasonToJSONTyped,
} from './CarveOutEligibilityReason';
import type { CarveOutSubmissionMethod } from './CarveOutSubmissionMethod';
import {
    CarveOutSubmissionMethodFromJSON,
    CarveOutSubmissionMethodFromJSONTyped,
    CarveOutSubmissionMethodToJSON,
    CarveOutSubmissionMethodToJSONTyped,
} from './CarveOutSubmissionMethod';
import type { CarveOutStatus } from './CarveOutStatus';
import {
    CarveOutStatusFromJSON,
    CarveOutStatusFromJSONTyped,
    CarveOutStatusToJSON,
    CarveOutStatusToJSONTyped,
} from './CarveOutStatus';
import type { CarveOutSource } from './CarveOutSource';
import {
    CarveOutSourceFromJSON,
    CarveOutSourceFromJSONTyped,
    CarveOutSourceToJSON,
    CarveOutSourceToJSONTyped,
} from './CarveOutSource';

/**
 * 
 * @export
 * @interface CarveOut
 */
export interface CarveOut {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    submission_id: string;
    /**
     * 
     */
    lead_medication_id?: string;
    /**
     * 
     */
    source: CarveOutSource;
    /**
     * 
     */
    status: CarveOutStatus;
    /**
     * 
     */
    status_updated_at?: string;
    /**
     * 
     */
    deferred_at?: string;
    /**
     * 
     */
    submitted_at?: string;
    /**
     * 
     */
    medication_name: string;
    /**
     * 
     */
    dosage?: string;
    /**
     * 
     */
    route?: string;
    /**
     * 
     */
    frequency?: string;
    /**
     * 
     */
    cost_per_day?: number;
    /**
     * 
     */
    j_code?: string;
    /**
     * 
     */
    ndc?: string;
    /**
     * 
     */
    stop_date?: string;
    /**
     * 
     */
    notes?: string;
    /**
     * 
     */
    eligibility_reason: CarveOutEligibilityReason;
    /**
     * Server-computed (Postgres generated column) from j_code and ndc both being present.
     */
    is_complete: boolean;
    /**
     * The step-2 checkbox state.
     */
    is_selected_for_submission: boolean;
    /**
     * 
     */
    user_edited_fields: Array<string>;
    /**
     * 
     */
    can_revert_status: boolean;
    /**
     * 
     */
    submission_method?: CarveOutSubmissionMethod;
    /**
     * 
     */
    quotes?: Array<CarveOutQuote>;
}



/**
 * Check if a given object implements the CarveOut interface.
 */
export function instanceOfCarveOut(value: object): value is CarveOut {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('submission_id' in value) || value['submission_id'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('medication_name' in value) || value['medication_name'] === undefined) return false;
    if (!('eligibility_reason' in value) || value['eligibility_reason'] === undefined) return false;
    if (!('is_complete' in value) || value['is_complete'] === undefined) return false;
    if (!('is_selected_for_submission' in value) || value['is_selected_for_submission'] === undefined) return false;
    if (!('user_edited_fields' in value) || value['user_edited_fields'] === undefined) return false;
    if (!('can_revert_status' in value) || value['can_revert_status'] === undefined) return false;
    return true;
}

export function CarveOutFromJSON(json: any): CarveOut {
    return CarveOutFromJSONTyped(json, false);
}

export function CarveOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOut {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'submission_id': json['submission_id'],
        'lead_medication_id': json['lead_medication_id'] == null ? undefined : json['lead_medication_id'],
        'source': CarveOutSourceFromJSON(json['source']),
        'status': CarveOutStatusFromJSON(json['status']),
        'status_updated_at': json['status_updated_at'] == null ? undefined : json['status_updated_at'],
        'deferred_at': json['deferred_at'] == null ? undefined : json['deferred_at'],
        'submitted_at': json['submitted_at'] == null ? undefined : json['submitted_at'],
        'medication_name': json['medication_name'],
        'dosage': json['dosage'] == null ? undefined : json['dosage'],
        'route': json['route'] == null ? undefined : json['route'],
        'frequency': json['frequency'] == null ? undefined : json['frequency'],
        'cost_per_day': json['cost_per_day'] == null ? undefined : json['cost_per_day'],
        'j_code': json['j_code'] == null ? undefined : json['j_code'],
        'ndc': json['ndc'] == null ? undefined : json['ndc'],
        'stop_date': json['stop_date'] == null ? undefined : json['stop_date'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'eligibility_reason': CarveOutEligibilityReasonFromJSON(json['eligibility_reason']),
        'is_complete': json['is_complete'],
        'is_selected_for_submission': json['is_selected_for_submission'],
        'user_edited_fields': json['user_edited_fields'],
        'can_revert_status': json['can_revert_status'],
        'submission_method': json['submission_method'] == null ? undefined : CarveOutSubmissionMethodFromJSON(json['submission_method']),
        'quotes': json['quotes'] == null ? undefined : ((json['quotes'] as Array<any>).map(CarveOutQuoteFromJSON)),
    };
}

export function CarveOutToJSON(json: any): CarveOut {
    return CarveOutToJSONTyped(json, false);
}

export function CarveOutToJSONTyped(value?: CarveOut | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'submission_id': value['submission_id'],
        'lead_medication_id': value['lead_medication_id'],
        'source': CarveOutSourceToJSON(value['source']),
        'status': CarveOutStatusToJSON(value['status']),
        'status_updated_at': value['status_updated_at'],
        'deferred_at': value['deferred_at'],
        'submitted_at': value['submitted_at'],
        'medication_name': value['medication_name'],
        'dosage': value['dosage'],
        'route': value['route'],
        'frequency': value['frequency'],
        'cost_per_day': value['cost_per_day'],
        'j_code': value['j_code'],
        'ndc': value['ndc'],
        'stop_date': value['stop_date'],
        'notes': value['notes'],
        'eligibility_reason': CarveOutEligibilityReasonToJSON(value['eligibility_reason']),
        'is_complete': value['is_complete'],
        'is_selected_for_submission': value['is_selected_for_submission'],
        'user_edited_fields': value['user_edited_fields'],
        'can_revert_status': value['can_revert_status'],
        'submission_method': CarveOutSubmissionMethodToJSON(value['submission_method']),
        'quotes': value['quotes'] == null ? undefined : ((value['quotes'] as Array<any>).map(CarveOutQuoteToJSON)),
    };
}

